import ReactGA from 'react-ga4';
import { FormControl,  Tooltip, Checkbox } from '@mui/material';
import { useStore } from 'react-admin';
import { useColorGradient } from '../../hooks/use-color';

export const ColorReverseCheck = () => {
  const [colorSchemeReverse, setColorSchemeReverse] = useStore('map.imageColorSchemeReverse', false);
  const [colorGradient] =  useColorGradient();

  const onChangeReverse = (checked: boolean) => {
    setColorSchemeReverse(checked);

    // Send event to Google Analytics
    ReactGA.event('change_image_color_scheme_reverse', {
      category: 'ImageColorScheme',
      action: 'Change Image Color Scheme Reverse',
      label: '',
      value: checked,
    });
  };

  const GradientIcon = () => (
    <span
      style={{
        display: 'inline-block',
        width: 24,
        height: 24,
        background: colorGradient,
        transform: 'scaleX(-1)',
        borderRadius: '1px',
        border: '1px solid #ccc',
        verticalAlign: 'middle',
      }}
    >
    </span>
  );

  return (
    <FormControl sx={{ width: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Tooltip title={'Reverse Colors'} placement='top-start'>
        <Checkbox
          checked={colorSchemeReverse}
          onChange={(event) => onChangeReverse(event.target.checked)}
          icon={<GradientIcon />}
          checkedIcon={<GradientIcon />}
        />
      </Tooltip>
    </FormControl>
  );
};
